import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 71.8 46.7",
  width: "71.8",
  height: "57.537",
  "xml:space": "preserve"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M18.6,30.5c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.1-0.2,0.2-0.2   c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.3-0.3-0.8-0.3-1.1,0c-0.1,0.1-0.1,0.1-0.2,0.2   c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3C18.5,30.4,18.5,30.5,18.6,30.5z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M43.7,26.6h-3.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h3.2c0.4,0,0.8-0.3,0.8-0.8S44.1,26.6,43.7,26.6z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M40.5,20.1h3.2c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-3.2c-0.4,0-0.8,0.3-0.8,0.8S40.1,20.1,40.5,20.1z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M52.7,28.1h3.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-3.1c-0.4,0-0.8,0.3-0.8,0.8S52.3,28.1,52.7,28.1z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M52.7,36.1h3.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-3.1c-0.4,0-0.8,0.3-0.8,0.8S52.3,36.1,52.7,36.1z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        d: "M52.7,20.1h3.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-3.1c-0.4,0-0.8,0.3-0.8,0.8S52.3,20.1,52.7,20.1z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_7),
      _createElementVNode("path", {
        d: "M71.1,14.7L52.3,8.6L31.6,1.9c0,0,0,0,0,0l-5.1-1.7c-0.4-0.1-0.8,0.1-0.9,0.5c-0.1,0.4,0.1,0.8,0.5,0.9l4.6,1.5v14.3   L0.7,24.2c-0.4,0.1-0.7,0.5-0.6,0.9c0.1,0.3,0.4,0.6,0.7,0.6c0.1,0,0.1,0,0.2,0l5.1-1.1v21.5c0,0.4,0.3,0.8,0.8,0.8h24.4   c0,0,0,0,0,0h9.2h6.1H65c0.4,0,0.8-0.3,0.8-0.8V14.5l5,1.6c0.1,0,0.2,0,0.2,0c0.3,0,0.6-0.2,0.7-0.5C71.7,15.2,71.5,14.8,71.1,14.7   z M7.6,24.2l15.1-3.4l7.9-1.8v26.2H26v-9.9c0-0.4-0.3-0.8-0.8-0.8H13c-0.4,0-0.8,0.3-0.8,0.8v9.9H7.6V24.2z M13.8,45.2v-9.1h10.7   v9.1H13.8z M41.3,45.2v-9.1h4.6v9.1H41.3z M64.2,14v31.2H47.4v-9.9c0-0.4-0.3-0.8-0.8-0.8h-6.1c-0.4,0-0.8,0.3-0.8,0.8v9.9h-7.7   V18.1V3.6l21,6.8L64.2,14z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_8)
    ])
  ]))
}
}

})